<script setup>
import { swalError, swalSuccess } from '@/helper';
import { update_option } from '@/services/option';
import { create_option } from '@/services/option';
import { get_option } from '@/services/option';
import { onMounted, ref } from 'vue';
import { VueDraggableNext } from 'vue-draggable-next'

const draggable = VueDraggableNext
const isLoading = ref(true)
onMounted(async()=>{
  await get_jobs()
  await get_positions()
  isLoading.value = false
})

const jobs = ref([])
async function get_jobs(){
  let response = await get_option('job_fields')
  if (response.error){
    swalError(response.result, true)
    return
  }
  if (response.result.data){
    jobs.value = parseJobs(response.result.data)
  }
}

const option = ref({})
function parseJobs(result){
  option.value = result
  return JSON.parse(result.attributes.config)
}

const tempJob = ref('')
function addJob(){
  jobs.value.push({
    name: tempJob.value,
    slug: generateSlug(tempJob.value)
  })
  tempJob.value = ''
}

function generateSlug(str) {
  return str
  .toLowerCase() // Convert the string to lowercase
  .trim() // Trim whitespace from both ends of the string
  .replace(/[\s\W-]+/g, '-') // Replace spaces, special characters, and hyphens with a single hyphen
  .replace(/^-+|-+$/g, ''); // Remove leading and trailing hyphens
}

async function saveJob(){
  let params = {
    name: 'job_fields',
    config: JSON.stringify(jobs.value),
    option_type: 'job_fields'
  }
  let response
  if (option.value.id){
    response = await update_option(option.value.id, params)
  }else{
    response = await create_option(params)
  }
  console.log("🚀 ~ saveJob ~ response:", response)
  if (response.error){
    swalError(response.result, true)
    return
  }
  jobs.value = parseJobs(response.result.data.data)
  swalSuccess('Job fields has been saved')
}

function removeJob(i){
  jobs.value.splice(i,1)
}

const positions = ref([])
const tempPosition = ref('')
async function get_positions(){
  let response = await get_option('working_positions')
  if (response.error){
    swalError(response.result, true)
    return
  }
  if (response.result.data){
    positions.value = parsePositions(response.result.data)
  }
}

function addPosition(){
  positions.value.push({
    name: tempPosition.value,
    slug: generateSlug(tempPosition.value)
  })
  tempPosition.value = ''
}

function removePosition(i){
  positions.value.splice(i,1)
}

const position_option = ref({})
function parsePositions(result){
  position_option.value = result
  return JSON.parse(result.attributes.config)
}

async function savePosition(){
  let params = {
    name: 'working_positions',
    config: JSON.stringify(positions.value),
    option_type: 'working_positions'
  }
  let response
  if (position_option.value.id){
    response = await update_option(position_option.value.id, params)
  }else{
    response = await create_option(params)
  }
  if (response.error){
    swalError(response.result, true)
    return
  }
  positions.value = parsePositions(response.result.data.data)
  swalSuccess('Level of position has been saved')
}
</script>

<template>
  <loadingCard v-if="isLoading" />
  <div v-else class="card">
    <CardHeader title="Registration Setting"/>
    <div class="card-body">
      <div class="card border shadow-none">
        <div class="card-body">
          <!-- Job Type -->
          <div>
            <form @submit.prevent="addJob()" class="col-8">
              <div class="d-flex mb-3 align-items-center">
                <label class="col-form-label">
                  Working Field
                </label>
                <input type="text" class="w-50 form-control mx-2" 
                placeholder="Healthcare"
                v-model="tempJob"
                >
                <div class="col-sm-3">
                  <button type="submit" class="icon-btn btn btn-light-success">
                    <vue-feather type="plus"></vue-feather>
                  </button>
                </div>
              </div>
            </form>
            
            <div class="container border p-2 rounded-2" v-auto-animate>
              <template v-if="jobs.length != 0">
                <template v-for="(i, index) in jobs">
                  <div class="d-inline-block my-1">
                    <div class="badge badge-light-primary badge-btn-primary d-inline-flex align-items-center me-2">
                      <p class="mb-0">{{ i.name }}</p>
                      <button @click="removeJob(index)" class="btn tag-btn-dark">
                        x
                      </button>
                    </div>
                  </div>
                </template>
              </template>
              <template v-else>
                <p>No data..</p>
              </template>
            </div>
            
            <div class="d-flex justify-content-end mt-3">
              <button @click="saveJob" type="submit" class="btn btn-light-success">
                Save
              </button>
            </div>
          </div>
          
          <!-- Working Position -->
          <div>
            <form @submit.prevent="addPosition()" class="col-8">
              <div class="d-flex mb-3 align-items-center">
                <label class="col-form-label">
                  Level of Position
                </label>
                <input type="text" class="w-50 form-control mx-2" 
                placeholder="Healthcare"
                v-model="tempPosition"
                >
                <div class="col-sm-3">
                  <button type="submit" class="icon-btn btn btn-light-success">
                    <vue-feather type="plus"></vue-feather>
                  </button>
                </div>
              </div>
            </form>

            <div class="container border p-2 rounded-2" v-auto-animate>
              <template v-if="positions.length != 0">
                <draggable :list="positions" :animation="200">
                  <div class="d-inline-block my-1" v-for="position in positions" :key="position">
                    <div href="#" class="badge badge-light-primary badge-btn-primary d-inline-flex align-items-center me-2">
                      <p class="mb-0">{{ position.name }}</p>
                      <button @click="removePosition(index)" class="btn tag-btn-dark">
                        x
                      </button>
                    </div>
                  </div>
                </draggable>
              </template>
              <template v-else>
                <p>No data..</p>
              </template>
            </div>
            
            <div class="d-flex justify-content-end mt-3">
              <button @click="savePosition()" type="submit" class="btn btn-light-success">
                Save
              </button>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</template>